import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { Controller } from 'react-hook-form';
import { get, has } from 'lodash';
import { Grid2 as Grid, IconButton } from '@mui/material';
import { EditLocationAltOutlined as MapIcon } from '@mui/icons-material';

import MapsModal from '../MapsModal';
import AnalyticsService from '../../../../../Services/AnalyticsService';
import Address from '../../../../Address';
import withOptional from '../../../../../Utils/Posts/Form/withOptional';

function FormAddress({
  control,
  watch,
  errors,
  setError,
  clearErrors = () => {},
  setValue,
  register,
  required,
  geojson,
  disabled,
  name = 'location',
  latName = 'created_on_lat',
  lngName = 'created_on_lng',
  hiddenLabel = false,
}: any) {
  const intl = useIntl();
  const location = watch(name);
  const [lat, lng] = watch([latName, lngName]);
  const [inputValue, setInputValue] = useState(location);
  const markerPlaced = lat && lng && !location;
  const label = hiddenLabel ? null : intl.formatMessage({ id: `POST_FORM.LOCALISATION_LABEL` });
  const placeholderDefault = intl.formatMessage({ id: `POST_FORM.LOCALISATION_PLACEHOLDER` });
  const [mapModalOpen, setMapModalOpen] = useState(false);
  const [placeholder, setPlaceholder] = useState(placeholderDefault);

  useEffect(() => {
    if (markerPlaced) {
      setPlaceholder(intl.formatMessage({ id: 'POST_FORM.LOCALISATION_MARKER_PLACED' }));
    } else {
      setPlaceholder(placeholderDefault);
    }
  }, [markerPlaced]);

  const onClear = () => {
    setInputValue(null);
    setValue(name, null);
    setValue(latName, null);
    setValue(lngName, null);
  };

  const addressInput = (testId: any) => (
    <Controller
      name={name}
      control={control}
      render={({ field: { onChange, ...rest } }: any) => (
        <Address
          {...rest}
          value={location} // TODO: should come from the contrloller
          geolocated={!!lat && !!lng}
          freeSolo={false}
          setError={setError}
          clearErrors={() => clearErrors(name)}
          inputValue={inputValue}
          disabled={disabled}
          setInputValue={setInputValue}
          name={name}
          data-testid={testId}
          helperText={get(errors, name)?.message}
          error={has(errors, name)}
          setAddress={({
            geometry: { coordinates },
            properties: { formatted: suggestionValue = null },
          }: any) => {
            onChange(suggestionValue);
            setValue(latName, coordinates[1]);
            setValue(lngName, coordinates[0]);
          }}
          onClear={onClear}
          placeholder={placeholder}
          label={withOptional(label, required)}
          hiddenLabel={hiddenLabel}
          required={required}
        />
      )}
    />
  );

  return (
    <>
      <Grid
        container
        spacing={1}
        sx={{
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <Grid size="grow">
          {addressInput('post-form-location')}

          <input type="hidden" {...register(latName)} />
          <input type="hidden" {...register(lngName)} />
        </Grid>

        <Grid>
          <IconButton
            disabled={disabled}
            aria-label={intl.formatMessage({ id: 'POST_FORM.LOCALISATION_SEE_MAP' })}
            color="primary"
            size="large"
            onClick={() => {
              AnalyticsService.track('Post - Form', 'Open location modal');
              setMapModalOpen(true);
            }}
          >
            <MapIcon fontSize="inherit" />
          </IconButton>
        </Grid>
      </Grid>

      <MapsModal
        name={name}
        latName={latName}
        lngName={lngName}
        open={mapModalOpen}
        setOpen={setMapModalOpen}
        setValue={setValue}
        setInputValue={setInputValue}
        onClear={onClear}
        lat={lat}
        lng={lng}
        geojson={geojson}
      >
        {addressInput('post-form-location-modal')}
      </MapsModal>
    </>
  );
}

export default FormAddress;
